export const VISIT_LATER_ERROR = '12019';
export const THE_USER_NOT_JOIN_THE_TEAM_ERROR = '12002';
export const CROSS_REGION_TEAM_APPLY_ERROR = '12023';
export const LOGIN_EXPIRED_ERROR = '1019';
